import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Table from './Table'
import SearchBar from '@common/SearchBar'
import styles from './style.module.less'
import { Modal, Input } from 'hljd'

const Item = SearchBar.Item

@observer
export default class extends Component {
  componentDidMount() {
    this.props.store.getTotalNum()
  }

  search = () => {
    this.props.store.$getList(1)
  }

  render() {
    const { visible, add, cancel, setParams } = this.props.store

    return (
      visible && (
        <Modal
          title="添加案例"
          visible={visible}
          onOk={add}
          onCancel={cancel}
          width={800}
        >
          <SearchBar
            onChange={setParams}
            onSearch={this.search}
            onAfterReset={setParams}
            searchText="查询"
          >
            <Item label="案例名称" name="title">
              <Input style={{ width: 200 }} onPressEnter={this.search} />
            </Item>
          </SearchBar>

          <div className={styles.tableBox}>
            <Table store={this.props.store} />
          </div>
        </Modal>
      )
    )
  }
}
